import { useRef, useEffect, useCallback } from 'react'

export function useStableCallback<Args extends unknown[], Return>(
  fn: (...args: Args) => Return,
): (...args: Args) => Return {
  const fnRef = useRef(fn)

  useEffect(() => {
    fnRef.current = fn
  }, [fn])

  return useCallback((...args: Args): Return => {
    return fnRef.current(...args)
  }, [])
}
